<template>
  <sweet-modal :title="$t('settings_COA') + ' - ' + (state === 'create' ? $t('settings_addGroup') : $t('settings_editGroup'))" blocking ref="modal" class="modal" v-on:close="close">
    <el-form :model="form" ref="form" status-icon :rules="rules" label-position="left">
      <el-form-item prop="dbCode">
        <el-input v-if="state !== 'create'" readonly :label="$t('settings_accountThink_GLAccounts_dbCode')" v-model="form.dbCode"></el-input>
      </el-form-item>
      <el-form-item prop="number">
        <el-input :label="$t('settings_accountThink_GLAccounts_accNo')" v-model="form.number"></el-input>
      </el-form-item>
      <el-form-item prop="type">
        <el-input readonly :label="$t('settings_accountThink_GLAccounts_(type)')" v-model="type.name"></el-input>
      </el-form-item>
      <el-form-item prop="class">
        <el-input readonly :label="$t('settings_accountThink_GLAccounts_(class)')" v-model="myClass.name"></el-input>
      </el-form-item>
      <el-form-item prop="name">
        <el-input :label="$t('settings_accountThink_GLAccounts_(group)')" v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item prop="contra" style="margin-bottom: 0;" :label="$t('settings_accountThink_GLAccounts_makeContra')">
        <el-checkbox v-model="form.contra" @change="makeContra"></el-checkbox>
      </el-form-item>
      <el-form-item prop="DRCRCode" style="margin-bottom: 0;" :label="$t('settings_accountThink_GLAccounts_setAs')">
        <el-radio-group  v-model="form.DRCRCode" size="small">
          <el-radio :disabled="form.DRCRCode === 'CR'" label="DR" border style="margin-right: 0;">DR</el-radio>
          <el-radio :disabled="form.DRCRCode === 'DR'" label="CR"  border>CR</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="makeInactive" style="margin-bottom: 0;" :label="$t('settings_accountThink_GLAccounts_makeInactive')">
        <el-checkbox v-model="form.makeInactive"></el-checkbox>
      </el-form-item>
      <el-form-item prop="clashflowId" style="margin-bottom: 0;" label="Cash Flow">
        <el-select v-model="form.clashflowId" no-data-text="no date" placeholder="Cash Flow" filterable clearable>
          <el-option
              v-for="item in cashFlowList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="modal__btn" style="float:right;">
        <el-button v-if="state === 'create'" @click="create('form')" type="primary">{{$t('general_add')}}</el-button>
        <el-button v-else @click="update('form')" type="primary">{{$t('general_update')}}</el-button>
      </el-form-item>
    </el-form>
  </sweet-modal>
</template>

<script>
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
export default {
  name: "COAAddGroupModal",
  props: {
    cashFlowList: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      state: 'create',
      form: {
        dbCode: null,
        number: null,
        contra: false,
        DRCRCode: 'CR',
        makeInactive: false,
        // form
        classId: null,
        filePath: [],
        name: null,
        clashflowId: null
      },
      rules: {
        name: [
          { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ]
      },
      params: null,
      type: {},
      myClass: {}
      // cashFlowList: ['Operating', 'Investing', 'Financing']
    }
  },
  components: {
    SweetModal
  },
  methods: {
    openModal(state, params) {
      this.params = params

      if (params.node.data.entityType === 'class') {
        this.form.classId = params.node.data.id
        this.form.filePath = params.node.data.filePath
        this.form.DRCRCode = params.node.data.DRCRCode
        this.form.clashflowId = params.node.data.clashflowId ? params.node.data.clashflowId : null
        this.myClass = params.node.data
        // get type object
        params.api.forEachNode((node, index) => {
          if (node.data.id === this.myClass.typeId && node.data.entityType === 'type') {
            this.type = node.data
          }
        })
      }

      // get class object
      // get type object
      if (params.node.data.entityType === 'group') {
        this.form.DRCRCode = params.node.data.DRCRCode
        params.api.forEachNode((node, index) => {
          if (node.data.id === params.node.data.classId && node.data.entityType === 'class') {
            this.myClass = node.data
            this.form.classId = node.data.id
            this.form.filePath = node.data.filePath
            this.form.clashflowId = node.data.clashflowId ? node.data.clashflowId : null
            params.api.forEachNode((node2, index2) => {
              // console.log('params.node.data', node2, this.myClass.typeId)
              if (node2.data.id === this.myClass.typeId && node2.data.entityType === 'type') {
                this.type = node2.data
              }
            })
          }
        })
      }

      this.state = state
      this.$refs.modal.open()
    },
    openModalEdit(state, params) {
      this.params = params
      this.form.DRCRCode = params.node.data.DRCRCode
      this.form.name = params.node.data.name
      this.form.number = params.node.data.number
      this.form.dbCode = params.node.data.code
      this.form.makeInactive = !params.node.data.active
      this.form.contra = params.node.data.contra
      this.form.clashflowId = params.node.data.clashflowId

      params.api.forEachNode((node, index) => {
        if (node.data.id === params.node.data.classId && node.data.entityType === 'class') {
          this.myClass = node.data
          this.form.classId = node.data.id
          this.form.filePath = node.data.filePath
          params.api.forEachNode((node2, index2) => {
            // console.log('params.node.data', node2, this.myClass.typeId)
            if (node2.data.id === this.myClass.typeId && node2.data.entityType === 'type') {
              this.type = node2.data
            }
          })
        }
      })
      this.state = state
      this.$refs.modal.open()
    },
    create(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          const payload = {
            classId: this.form.classId,
            filePath: this.form.filePath,
            name: this.form.name,
            number: this.form.number,
            active: !this.form.makeInactive,
            DRCRCode: this.form.DRCRCode,
            contra: this.form.contra,
            clashflowId: this.form.clashflowId
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/accountGroup/create?companyId=${this.$route.query.companyId}`, payload)
              .then(response => {
                console.log('response', response.data);
                this.notification(this.$t('general_success'), this.$t('setting_groupCreated'), "success");
                this.$emit('loadList', { entityType: response.data.entityType, id: response.data.id })
                loader.hide()
                this.$refs.modal.close()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              })
        }
      })
    },
    update(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          const payload = {
            DRCRCode: this.form.DRCRCode,
            name: this.form.name,
            number: this.form.number,
            active: !this.form.makeInactive,
            contra: this.form.contra,
            clashflowId: this.form.clashflowId
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/accountGroup/update?groupId=${this.params.node.data.id}`, payload)
              .then(response => {
                console.log('response', response.data);
                this.notification(this.$t('general_success'), this.$t('setting_groupUpdated'), "success");
                this.$emit('loadList', { entityType: 'group', id: this.params.node.data.id })
                loader.hide()
                this.$refs.modal.close()
              })
              .catch(error => {
                console.log('An error occurred', error);
                loader.hide()
              })
        }
      })
    },
    makeContra(val) {
      this.form.DRCRCode = !val ? this.myClass.DRCRCode : (this.myClass.DRCRCode === 'DR' ? 'CR' : 'DR')
    },
    close() {
      this.state = 'create'
      this.form.dbCode = null
      this.form.type = null
      this.form.DRCRCode = 'CR'
      this.form.classId = null
      this.form.filePath = []
      this.form.name = null
      this.form.clashflowId = null
      this.form.contra = false
      this.form.number = null
      this.form.makeInactive = false
      this.params = null
      this.type = {}
      this.myClass = {}
      this.$refs['form'].resetFields()
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    }
  }
}
</script>

<style scoped>

</style>
